import * as React from 'react'
import { inject, observer } from 'mobx-react'
import Switch from 'react-bootstrap-switch'
import HttpActionsService from '../../Services/HttpActionsService'
import { Label } from 'react-bootstrap'
import LocalizationStore from '../../Stores/LocalizationStore'
import { User } from '../../Model/User'

interface IUserIsActiveComponentProps {
    user: User,
    showLabels?: boolean,
    httpActionsService?: HttpActionsService
}

@inject('httpActionsService')
@observer
export default class UserIsActiveComponent extends React.Component<IUserIsActiveComponentProps> {

    constructor(props: IUserIsActiveComponentProps) {
        super(props)  
    }

    handleActiveSwitchChange(el: any) {
        this.props.httpActionsService!.toggleIsActiveUser(this.props.user.id)  
    }
    
    render() {
        const ls = LocalizationStore.getInstance()

        return (
            <div className="switchForm">
                <Label 
                    hidden={this.props.user ? this.props.user!.isActive : true}
                >
                    {ls.t('toMakeActive')}
                </Label>
                <Label 
                    hidden={!(this.props.user ? this.props.user!.isActive : true)}
                >
                    {ls.t('toMakeDisactive')}
                </Label>
                <Switch
                    wrapperClass="switchWrapper"
                    labelText=""
                    onText=""
                    offText=""
                    onChange={(el) => this.handleActiveSwitchChange(el)}
                    value={this.props.user ? this.props.user!.isActive : true}
                />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Components/UserIsActiveComponent/index.tsx